import { __awaiter, __generator } from "tslib";
import { addNcpcCode } from '@ekuaibao/lib/lib/addNcpcCode';
import { app, callback } from '../index.v0';
import { newHomeConfig } from '../newHomeConfig';
import { initDatafluxRum } from '../dataflux-rum';
import QYWeiXinSDK from '@ekuaibao/sdk-bridge/sdk/qyweixin';
import registerAPI from '../registerAPI';
import { initializeTitle } from '../initializeTitle';
import initPlatformInfo from '../initPlatformInfo';
import registerHandler from '../registerHandler';
import { initRoute } from '../initRoute';
import { initColors } from '../initColors';
import setNetworkAdapter from '../setNetworkAdapter';
import initLogger from '../../logger/initLogger';
initLogger();
window.__PLANTFORM__ = 'WEIXIN';
initDatafluxRum();
function startup() {
    app.use({
        id: '@weixin',
        onready: function () {
            addNcpcCode();
        }
    });
    callback();
}
export var bootstrap = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                initColors();
                app.container.set('IDeviceType', 'DESKTOP');
                app.container.set('ISMessageEntry', false);
                app.sdk = app.container.get(QYWeiXinSDK);
                registerHandler();
                return [4, app.sdk.initialize()];
            case 1:
                _a.sent();
                initRoute();
                initPlatformInfo();
                return [4, newHomeConfig()];
            case 2:
                _a.sent();
                initializeTitle();
                registerAPI();
                setNetworkAdapter();
                return [4, startup()];
            case 3:
                _a.sent();
                setNetworkAdapter();
                return [2];
        }
    });
}); };
